import React, { useContext } from "react";
import { 
    Form,
    Container, Row, Col, Button, Modal, Card, Image } from "react-bootstrap";
import { colors, contact, mainImage } from "../configs";
import { QRCodeSVG } from "qrcode.react";

const { white } = colors;


function Modal_LoginByScan({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  size='md',
  docId
}) {


  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      size={size}
    >
      <Modal.Header closeButton>
        <h1><b>เข้าใช้งานด้วยการสแกน</b></h1>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'transparent'}} >
            <div style={{display:'flex', justifyContent:'center',alignItems:'center', margin:10, flexDirection:'column'}} >
                <QRCodeSVG value={docId} />
                <br/>
                <h4>QR Code เพื่อเข้าใช้งาน</h4>
            </div>
            <h6>1. เข้าแอปช็อปแชมป์ ไปยัง ร้านค้าของคุณ</h6>
            <h6>2. เลือกไอคอน "ตั้งค่า"</h6>
            <h6>3. เลือก หัวข้อที่ 5. เชื่อมต่อเว็บไซต์ระบบหลังบ้าน </h6>
            <h6>4. กดปุ่มสีเหลือง "สแกนตอนนี้"</h6>
            <h6>5. สแกน Qr Code ด้านบน เพื่อเข้าใช้งาน"</h6>

      </Modal.Body>
    </Modal>
  );
};

const styles = {
    container : {
      width: "100%",
      height: "100vh", // Full viewport height
      backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/owner%2Fshopchamp_background_with_logo.png?alt=media&token=4cb0cdba-57a9-4de0-9fbe-71d8b41ee760')",
      backgroundSize: "cover", // Ensures the image covers the entire div
      backgroundPosition: "center", // Centers the image
      backgroundRepeat: "no-repeat", // Prevents image from repeating
      display:'flex',
      justifyContent:'center',
      alignItems:'center'
    },
    container2 : {
      backgroundColor:white,
      borderRadius:50,
      padding:20,
      paddingTop:5,
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      width:'25%',
      minWidth:'300px',
      opacity:0.9,
      marginTop:100
    },
    container3 : {
      width:'100%',borderRadius:20,marginTop:10,paddingTop:30,paddingBottom:30, marginBottom:10
    },
    container4 : {
      width:'100%'
    },
    container5 : {
      display:'flex',width:'50%',justifyContent:'flex-end',minWidth:320
    },
    img : {
      width: '200px', borderRadius:'1rem'
    }
  }

export default Modal_LoginByScan;
